import React from 'react';
import './index.css';

interface Props {
  logo: string;
  width?: any;
  height?: any;
}
export default class BrandShopLogo extends React.Component<Props, any> {
  render() {
    const { logo, width, height } = this.props;
    return (
      logo && (
        <view className="container" style={{ width: width || 32, height: height || 32 }}>
          <image
            src={logo}
            style={{ width: '100%', height: '100%' }}
            placeholder="assets://placeholder/icon_placeholder_1:1.png"
            error="assets://placeholder/icon_placeholder_1:1.png"
          />
        </view>
      )
    );
  }
}
